import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useStore } from 'dashboard/composables/store';
import { parseAPIErrorResponse } from 'dashboard/store/utils/api';
import MessageApi from 'dashboard/api/inbox/message';

// Oculta a imagem ou o vídeo da mensagem para toda a empresa. A mensagem atualizada
// chega aos demais agentes em tempo real pelo evento message.updated.
export function useMediaVisibility({ id, conversationId }) {
  const { t } = useI18n();
  const store = useStore();
  const isUpdatingVisibility = ref(false);

  const hideMedia = async () => {
    if (isUpdatingVisibility.value) return;
    isUpdatingVisibility.value = true;
    try {
      const { data } = await MessageApi.setMediaVisibility(
        conversationId.value,
        id.value,
        true
      );
      store.dispatch('updateMessage', data);
      useAlert(t('CONVERSATION.CONTEXT_MENU.HIDE_MEDIA_SUCCESS'));
    } catch (error) {
      useAlert(parseAPIErrorResponse(error));
    } finally {
      isUpdatingVisibility.value = false;
    }
  };

  return { hideMedia, isUpdatingVisibility };
}
